export default {
  SET_ORGANIZATION_USERS(state, payload) {
    state.organizationUsers = payload
  },
}
